var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5.86c-.305 0-.555.132-.852.374L.383 5.484a1 1 0 0 0-.367.774c0 .617.5 1.055 1.047 1.055q.398 0 .773-.305L6.5 3.273l4.656 3.735c.25.203.516.305.774.305a1.05 1.05 0 0 0 1.054-1.055 1 1 0 0 0-.367-.774l-5.273-4.25C7.047.992 6.797.86 6.5.86m0 14.859c.297 0 .547-.14.844-.375l5.273-4.258a.98.98 0 0 0 .367-.774c0-.609-.5-1.054-1.054-1.054-.258 0-.524.11-.774.305L6.5 13.305 1.836 9.563c-.25-.196-.508-.305-.774-.305-.546 0-1.046.445-1.046 1.055 0 .32.14.585.367.773l5.265 4.258c.297.234.547.375.852.375"
  })));
};
export default SvgExpand;